import { enumFiltroTipo, colorsSystem } from '@common/util/defaultValues';
import IntlMessage from "../../helpers/intlMessage";
import React from 'react';

export const returnParamiters = ({
  periodoInicial,
  periodoFinal,
  tipo,
  value
}) => {
  switch (tipo) {
    case enumFiltroTipo.DATA_ENTREGA:
      return { dataEntregaDe: periodoInicial, dataEntregaAte: periodoFinal };
    case enumFiltroTipo.DATA_SOLICITACAO:
      return {
        dataSolicitacaoDe: periodoInicial,
        dataSolicitacaoAte: periodoFinal
      };
    case enumFiltroTipo.NR_EXAME:
      return { numeroExame: value };
    case enumFiltroTipo.NR_PEDIDO:
      return { numeroPedido: value };
    case enumFiltroTipo.NOME_PACIENTE:
      return { paciente: value };
    case enumFiltroTipo.OBSERVACAO_LAUDO:
      return { observacao: value };
    case enumFiltroTipo.TIPO_EXAME:
      return { tipoExame: value };
    case enumFiltroTipo.URGENTE:
      return { urgente: Boolean(value) ? 1 : 2 };
    default:
      return {};
  }
};

export const returnStatus = item => {
  const color = '#fff';
  if (item.isLiberadoTotal) {
    return {
      backgroundColor: colorsSystem.VERDE,
      color,
      label: <IntlMessage id = "dashboards.reports.released"/>
    };
  }
  if (item.isLiberadoParcial) {
    return {
      backgroundColor: colorsSystem.LARANJA,
      color,
      label: <IntlMessage id = "dashboards.reports.partiallyReleased"/>
    };
  }
  return {
    backgroundColor: colorsSystem.AMARELO,
    color: '#333',
    label: <IntlMessage id = "dashboards.reports.inProgress"/>
  };
};



// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.utils.js